import React, { Component } from "react";
import {
    Container,
    Box,
    Grid,
    Typography,
    Button,
    Paper,
    Breadcrumbs,
    Tabs,
    Tab,
    Link as MuiLink,
    CircularProgress,
    Avatar,
    Chip,
    Card,
    CardContent
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ForumIcon from '@mui/icons-material/Forum';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SourceIcon from '@mui/icons-material/Source';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import RsvpIcon from '@mui/icons-material/Rsvp';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import CampaignIcon from '@mui/icons-material/Campaign';
import SettingsIcon from '@mui/icons-material/Settings';
import BoltIcon from '@mui/icons-material/Bolt';
import BuildIcon from '@mui/icons-material/Build';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import ComputerIcon from '@mui/icons-material/Computer';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import GroupsIcon from '@mui/icons-material/Groups';
import MemoryIcon from '@mui/icons-material/Memory';
import { isAuthenticated } from "../auth";
import DeviceLibraryTab from '../library/DeviceLibraryTab';
import { LIBRARY_GROUP_IDS } from '../library/libraryConstants';
import ForumPosts from "../forum/ForumPosts";
import FileList from "../file/FileList";
import PresentationList from '../group/PresentationList';
import Presentations27List from '../group/Presentations27List';
import PastEventList from '../event/PastEventList';
import { singleGroup, groupDetails } from "./apigroup";
import { Link, Redirect } from "react-router-dom";
import EventCalendar from "../event/EventCalendar";
import moment from "moment";
import Footer from '../core/Footer';



import MonthlyMeetingList from "./monthlymeeting";
import Voting from "./Voting";

const TAB_VALUES = ['posts', 'calendar', 'events', 'presentations27', 'content', 'monthly', 'monthlyinvite', 'voting', 'library'];

// ?tab=<value> opens that tab on load (deep links such as ?tab=library&item=<id>)
const initialTab = (search, groupId) => {
  const tab = new URLSearchParams(search).get('tab');
  if (!TAB_VALUES.includes(tab)) return 'posts';
  if (tab === 'library' && !LIBRARY_GROUP_IDS.includes(groupId)) return 'posts';
  return tab;
};

class SingleGroup extends Component {

  state = {
    userId: isAuthenticated() && isAuthenticated().userId, 
    username: isAuthenticated() && isAuthenticated().email,
    groupId: this.props.match.params.groupId,
    group: '',
    chairId: '',
    redirectToHome: false,
    redirectToSignin: false,
    chair: '',
    cochair: '',
    redirectToSignJoinRequest: false,
    mainResourceName: undefined,
    calendarName: undefined,
    activeContent: initialTab(this.props.location.search, this.props.match.params.groupId)
  };


  theme = {
    background: 'white',
    fontFamily: 'Arial, Helvetica, sans-serif',
    headerBgColor: "#327fa8",
    headerFontColor: "#fff",
    headerFontSize: "25px",
    botBubbleColor: "#327fa8",
    botFontColor: "#fff",
    userBubbleColor: "#fff",
    userFontColor: "#4c4c4c"
  };


  componentDidMount = () => {

    singleGroup(this.state.groupId).then(data => {
      if (data.error) {
        console.log(data.error);
      } else {
        this.setState({
          group: data,
          // chair: data.chair,
          // chairId: data.chair._id,
          // cochair: data.cochair
        });

        groupDetails(this.state.groupId).then(data => {
          if (data.error) {
            console.log(data.error);
          } else {
            this.setState({
              group: data,
              chair: data.chair,
              chairId: data.chair._id,
              cochair: data.cochair
            })

          }
          this.verifyAccess(data._id, data.members, this.state.userId);
        });
      }

    });

    // ReactGA.initialize('UA-331790-15')
    // ReactGA.pageview('/singlegroup/' + this.state.groupId);

    if (this.state.groupId === '5e2a5e764175b97d84ec6cae') { this.setState({ mainResourceName: 'Physical Committee', calendarName: 'Physical' }) }
    if (this.state.groupId === '5e44050f4e6ed37ab467d0f2') { this.setState({ mainResourceName: 'Electrical Committee', calendarName: 'Electrical' }) }
    if (this.state.groupId === '5e44052e4e6ed37ab467d0f3') { this.setState({ mainResourceName: 'Technology Committee', calendarName: 'Technology' }) }
    if (this.state.groupId === '5e4405864e6ed37ab467d0f4') { this.setState({ mainResourceName: 'Civil Committee', calendarName: 'Civil' }) }
    if (this.state.groupId === '5e4406454e6ed37ab467d0f5') { this.setState({ mainResourceName: 'Business Strategy Committee', calendarName: 'Business' }) }
    if (this.state.groupId === '5e5591a97ff73f6d34835a05') { this.setState({ mainResourceName: 'General Committee', calendarName: 'General' }) }
    if (this.state.groupId === '639242d4971a30726884fd85') { this.setState({ mainResourceName: 'Innovation Commitee', calendarName: 'Innovation' }) }
    if (this.state.groupId === '65ce5e76e54fd763dfc9c0ae') { this.setState({ mainResourceName: 'Content Sub Committee', calendarName: 'Content' }) }

  };

  handleTabChange = (event, newValue) => {
    this.setState({
      activeContent: newValue
    })
    // The library keeps its filters in the query string; drop them on leaving
    if (newValue === 'library' || this.state.activeContent === 'library') {
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: newValue === 'library' ? '?tab=library' : ''
      });
    }
  };

  getCommitteeIcon = (groupName) => {
    const name = groupName.toLowerCase();
    if (name.includes('electrical')) return <BoltIcon sx={{ fontSize: 64 }} />;
    if (name.includes('physical')) return <BuildIcon sx={{ fontSize: 64 }} />;
    if (name.includes('civil') || name.includes('structural')) return <ArchitectureIcon sx={{ fontSize: 64 }} />;
    if (name.includes('technology') || name.includes('tech')) return <ComputerIcon sx={{ fontSize: 64 }} />;
    if (name.includes('business') || name.includes('strategy')) return <BusinessCenterIcon sx={{ fontSize: 64 }} />;
    if (name.includes('innovation')) return <LightbulbIcon sx={{ fontSize: 64 }} />;
    return <GroupsIcon sx={{ fontSize: 64 }} />;
  };

  verifyAccess = (groupId, members, userId) => {

    let userisMember = false

    if (groupId !== '5e971eab6d698b2e84041439') {
      if (members.length === 0) {
        userisMember = true
      } else {

        const b = members.find((member) => member._id === userId)
        if (b) {
          userisMember = false
        } else {
          userisMember = true
        }

      }

      this.setState({ redirectToSignJoinRequest: userisMember })
    }
  }



  render() {
    const { group, chair, cochair } = this.state;

    if (this.state.redirectToSignJoinRequest) {
      return <Redirect to={`/group/requestaccess/${this.state.groupId}`} />
    }

    // Wait for data to load before rendering
    if (!group || !chair || !cochair) {
      return (
        <Container maxWidth={false}>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '400px', gap: 2 }}>
            <CircularProgress size={60} />
            <Typography variant="h5">Loading committee information...</Typography>
          </Box>
        </Container>
      );
    }




    const getresourceList = () => {
      switch (this.state.groupId) {
        case '5e2a5e764175b97d84ec6cae':
          return (
            [
              {
                fieldName: 'physical',
                title: 'Physical Committee',
                allowMultiple: true,
                instances: [
                  { id: 1, text: 'Committee Update', color: '#993399' },
                  { id: 2, text: 'Monthly Meeting', color: '#993399' },
                  { id: 3, text: 'Committee Presentation', color: '#993399' },
                  { id: 4, text: 'Vendor Presentation', color: '#993399' }
                ]
              }
            ]
          )
        case '5e44050f4e6ed37ab467d0f2':
          return (
            [
              {
                fieldName: 'electrical',
                title: 'Electrical Committee',
                allowMultiple: true,
                instances: [
                  { id: 1, text: 'Committee Update', color: '#f44336' },
                  { id: 2, text: 'Monthly Meeting', color: '#f44336' },
                  { id: 3, text: 'Committee Presentation', color: '#f44336' },
                  { id: 4, text: 'Vendor Presentation', color: '#f44336' }
                ],
              }
            ]
          )
        case '5e44052e4e6ed37ab467d0f3':
          return (
            [
              {
                fieldName: 'technology',
                title: 'Technology Committee',
                allowMultiple: true,
                instances: [
                  { id: 1, text: 'Committee Update', color: '#339966' },
                  { id: 2, text: 'Monthly Meeting', color: '#339966' },
                  { id: 3, text: 'Committee Presentation', color: '#339966' },
                  { id: 4, text: 'Vendor Presentation', color: '#339966' }
                ],
              }
            ]
          )
        case '5e4405864e6ed37ab467d0f4':
          return (
            [
              {
                fieldName: 'civil',
                title: 'Civil Committee',
                allowMultiple: true,
                instances: [
                  { id: 1, text: 'Committee Update', color: '#795548' },
                  { id: 2, text: 'Monthly Meeting', color: '#795548' },
                  { id: 3, text: 'Committee Presentation', color: '#795548' },
                  { id: 4, text: 'Vendor Presentation', color: '#795548' }
                ],
              }
            ]
          )
        case '5e4406454e6ed37ab467d0f5':
          return (
            [
              {
                fieldName: 'bizstrategy',
                title: 'Business Strategy Committee',
                allowMultiple: true,
                instances: [
                  { id: 1, text: 'Committee Update', color: '#000099' },
                  { id: 2, text: 'Monthly Meeting', color: '#000099' },
                  { id: 3, text: 'Committee Presentation', color: '#000099' },
                  { id: 4, text: 'Vendor Presentation', color: '#000099' }
                ],
              }
            ]
          )
        case '639242d4971a30726884fd85':
          return (
            [
              {
                fieldName: 'innovative',
                title: 'Innovative Solutions Committee',
                allowMultiple: true,
                instances: [
                  { id: 1, text: 'Committee Update', color: '#000099' },
                  { id: 2, text: 'Monthly Meeting', color: '#000099' },
                  { id: 3, text: 'Committee Presentation', color: '#000099' },
                  { id: 4, text: 'Vendor Presentation', color: '#000099' }
                ],
              }
            ]
          )
        case '65ce5e76e54fd763dfc9c0ae':
          return (
            [
              {
                fieldName: 'content',
                title: 'Content Sub Committee',
                allowMultiple: true,
                instances: [
                  { id: 1, text: 'Committee Update', color: '#000099' },
                  { id: 2, text: 'Monthly Meeting', color: '#000099' }
                ],
              }
            ]
          )
        default:

          return (
            [
              {
                fieldName: 'general',
                title: 'General Sessions',
                allowMultiple: true,
                instances: [
                  { id: 1, text: 'Committee Update', color: '#4caf50' },
                  { id: 2, text: 'Monthly Meeting', color: '#4caf50' },
                  { id: 3, text: 'Committee Presentation', color: '#4caf50' },
                  { id: 4, text: 'Vendor Presentation', color: '#4caf50' }
                ],
              }
            ]
          )
      };
    };



    return (
      <>
        {/* Hero Section */}
        <Box
          sx={{
            backgroundColor: '#003E7E',
            color: 'white',
            py: 3
          }}
        >
          <Container maxWidth="lg">
            {/* Breadcrumbs */}
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              sx={{ mb: 2, '& .MuiBreadcrumbs-separator, & a, & p': { color: 'rgba(255, 255, 255, 0.7)' } }}
            >
              <MuiLink component={Link} to="/usershome" underline="hover">
                Home
              </MuiLink>
              <MuiLink component={Link} to="/grouplist" underline="hover">
                Committees
              </MuiLink>
              <Typography sx={{ color: 'white !important' }}>{group.name}</Typography>
            </Breadcrumbs>

            {/* Main Content: Left side header + Right side cards */}
            <Grid container spacing={3}>
              {/* Left Side - Committee Info */}
              <Grid item xs={12} md={7}>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2, mb: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {this.getCommitteeIcon(group.name)}
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1, flexWrap: 'wrap', gap: 1 }}>
                      <Typography variant="h3" component="h1" sx={{ fontWeight: 600, fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' } }}>
                        {group.name}
                      </Typography>
                      <Button
                        component={MuiLink}
                        href={`/admin/committee/${this.state.groupId}`}
                        variant="outlined"
                        size="small"
                        startIcon={<SettingsIcon />}
                        sx={{
                          color: 'white',
                          borderColor: 'rgba(255, 255, 255, 0.3)',
                          ml: 2,
                          '&:hover': {
                            borderColor: '#FF6600',
                            backgroundColor: 'rgba(255, 102, 0, 0.1)'
                          }
                        }}
                      >
                        Admin
                      </Button>
                    </Box>
                    <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.9)', mb: 1.5, lineHeight: 1.6 }}>
                      {group.description}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)' }}>
                      Welcome, {isAuthenticated().name}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Right Side - Chair & Co-Chair Cards Stacked */}
              <Grid item xs={12} md={5}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {/* Chair Card */}
                  <Card
                    sx={{
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255, 255, 255, 0.2)'
                    }}
                  >
                    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Avatar
                          sx={{
                            width: 48,
                            height: 48,
                            bgcolor: '#FF6600'
                          }}
                        >
                          {chair.name.charAt(0)}{chair.lastName.charAt(0)}
                        </Avatar>
                        <Box sx={{ flex: 1 }}>
                          <Chip label="Chair" size="small" sx={{ mb: 0.5, backgroundColor: '#FF6600', color: 'white', height: 20, fontSize: '0.7rem' }} />
                          <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 600, lineHeight: 1.2 }}>
                            {chair.name} {chair.lastName}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)', display: 'block' }}>
                            {chair.companyName}
                          </Typography>
                        </Box>
                        <Button
                          component={MuiLink}
                          href={`/user/${chair._id}`}
                          variant="text"
                          size="small"
                          sx={{
                            color: '#FF6600',
                            minWidth: 'auto',
                            p: 0.5,
                            '&:hover': { backgroundColor: 'rgba(255, 102, 0, 0.1)' }
                          }}
                        >
                          →
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>

                  {/* Co-Chair Card */}
                  <Card
                    sx={{
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255, 255, 255, 0.2)'
                    }}
                  >
                    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Avatar
                          sx={{
                            width: 48,
                            height: 48,
                            bgcolor: 'rgba(255, 255, 255, 0.2)'
                          }}
                        >
                          {cochair.name.charAt(0)}{cochair.lastName.charAt(0)}
                        </Avatar>
                        <Box sx={{ flex: 1 }}>
                          <Chip label="Co-Chair" size="small" sx={{ mb: 0.5, backgroundColor: 'rgba(255, 255, 255, 0.2)', color: 'white', height: 20, fontSize: '0.7rem' }} />
                          <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 600, lineHeight: 1.2 }}>
                            {cochair.name} {cochair.lastName}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)', display: 'block' }}>
                            {cochair.companyName}
                          </Typography>
                        </Box>
                        <Button
                          component={MuiLink}
                          href={`/user/${cochair._id}`}
                          variant="text"
                          size="small"
                          sx={{
                            color: '#FF6600',
                            minWidth: 'auto',
                            p: 0.5,
                            '&:hover': { backgroundColor: 'rgba(255, 102, 0, 0.1)' }
                          }}
                        >
                          →
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* Navigation Tabs - Sticky */}
        <Paper
          elevation={2}
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1300,
            borderRadius: 0,
            borderBottom: '2px solid #e0e0e0'
          }}
        >
          <Container maxWidth="lg">
            <Box sx={{ position: 'relative' }}>
              {/* Right fade gradient — hints that more tabs exist */}
              <Box
                sx={{
                  display: { xs: 'block', lg: 'none' },
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  bottom: 0,
                  width: 40,
                  background: 'linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1))',
                  zIndex: 2,
                  pointerEvents: 'none',
                }}
              />
              <Tabs
                value={this.state.activeContent}
                onChange={this.handleTabChange}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                sx={{
                  '& .MuiTab-root': {
                    minHeight: { xs: 52, sm: 64 },
                    fontSize: { xs: '0.8rem', sm: '0.95rem' },
                    fontWeight: 500,
                    textTransform: 'none',
                    minWidth: { xs: 'auto', sm: 100 },
                    px: { xs: 1.5, sm: 2 },
                  },
                  '& .Mui-selected': {
                    color: '#FF6600 !important'
                  },
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#FF6600',
                    height: 3
                  },
                  '& .MuiTabs-scrollButtons': {
                    width: 32,
                    color: '#003E7E',
                    opacity: 1,
                    '&.Mui-disabled': {
                      opacity: 0.3,
                    },
                    '& svg': {
                      fontSize: 28,
                    },
                  },
                }}
              >
                <Tab
                  icon={<ForumIcon />}
                  iconPosition="start"
                  label="Posts"
                  value="posts"
                />
                <Tab
                  icon={<CalendarMonthIcon />}
                  iconPosition="start"
                  label="Calendar"
                  value="calendar"
                />
                <Tab
                  icon={<EmojiEventsIcon />}
                  iconPosition="start"
                  label="Events"
                  value="events"
                />
                {LIBRARY_GROUP_IDS.includes(this.state.groupId) && (
                  <Tab
                    icon={<MemoryIcon />}
                    iconPosition="start"
                    label="Device Library"
                    value="library"
                  />
                )}
                {this.state.groupId === '5e5591a97ff73f6d34835a05' && (
                  <Tab
                    icon={<CampaignIcon />}
                    iconPosition="start"
                    label="27 Presentations"
                    value="presentations27"
                  />
                )}
                <Tab
                  icon={<SourceIcon />}
                  iconPosition="start"
                  label="Content"
                  value="content"
                />
                <Tab
                  icon={<RecordVoiceOverIcon />}
                  iconPosition="start"
                  label="Recordings"
                  value="monthly"
                />
                <Tab
                  icon={<RsvpIcon />}
                  iconPosition="start"
                  label="Invite"
                  value="monthlyinvite"
                />
                <Tab
                  icon={<HowToVoteIcon />}
                  iconPosition="start"
                  label="Voting"
                  value="voting"
                />
              </Tabs>
            </Box>
          </Container>
        </Paper>

        {/* Main Content Area - Full Width */}
        <Container maxWidth="lg" sx={{ my: 4 }}>
          <Box>
            {(this.state.activeContent === 'monthlyinvite') && (
              <Box>
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 600, color: '#003E7E' }}>
                  Monthly Meeting Invite
                </Typography>
                <MonthlyMeetingList groupId={this.props.match.params.groupId} />
              </Box>
            )}

            {(this.state.activeContent === 'voting') && (
              <Box>
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 600, color: '#003E7E' }}>
                  Committee Voting
                </Typography>
                <Voting
                  groupId={this.props.match.params.groupId}
                  chairId={this.state.chairId}
                  cochairId={this.state.cochair && this.state.cochair._id}
                />
              </Box>
            )}

            {(this.state.activeContent === 'posts') && (
              <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                  <Typography variant="h4" sx={{ fontWeight: 600, color: '#003E7E' }}>
                    Discussion Posts
                  </Typography>
                  <Button
                    component={Link}
                    to={`/forumpost/create/${this.props.match.params.groupId}`}
                    variant="contained"
                    sx={{
                      backgroundColor: '#FF6600',
                      '&:hover': { backgroundColor: '#e55a00' }
                    }}
                  >
                    Create New Post
                  </Button>
                </Box>
                <ForumPosts groupId={this.state.groupId} />
              </Box>
            )}

            {(this.state.activeContent === 'events') && (
              <Box>
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 600, color: '#003E7E' }}>
                  SDSIC Events
                </Typography>
                <PastEventList />
              </Box>
            )}

            {(this.state.activeContent === 'presentations27') && (
              <Box>
                <Typography variant="h4" sx={{ mb: 1, fontWeight: 600, color: '#003E7E' }}>
                  2027 Presentation Submissions
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
                  Presentations submitted through the Call for Presentations for the 2027 SDSIC Conference.
                </Typography>
                <Presentations27List />
              </Box>
            )}

            {(this.state.activeContent === 'content') && (
              <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                  <Typography variant="h4" sx={{ fontWeight: 600, color: '#003E7E' }}>
                    Shared Content
                  </Typography>
                  <Button
                    component={MuiLink}
                    href={`/file/create/${this.props.match.params.groupId}`}
                    variant="contained"
                    sx={{
                      backgroundColor: '#FF6600',
                      '&:hover': { backgroundColor: '#e55a00' }
                    }}
                  >
                    Add File
                  </Button>
                </Box>
                <FileList groupId={this.props.match.params.groupId} chairId={this.state.chairId} cochairId={this.state.cochair && this.state.cochair._id} />
              </Box>
            )}

            {(this.state.activeContent === 'library') && (
              <DeviceLibraryTab groupId={this.props.match.params.groupId} />
            )}

            {(this.state.activeContent === 'monthly') && (
              <Box>
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 600, color: '#003E7E' }}>
                  Monthly Recordings
                </Typography>
                <PresentationList groupId={this.props.match.params.groupId} />
              </Box>
            )}

            {(this.state.activeContent === 'calendar') && (
              <Box>
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 600, color: '#003E7E' }}>
                  Committee Calendar
                </Typography>
                {this.state.calendarName && (
                  <EventCalendar
                    scheduleName={this.state.calendarName}
                    isAdmin={false}
                    chooseTracks={false}
                    chooseDays={false}
                    currentDate={moment().format("YYYY-MM-DD")}
                    excludedDays={[0, 1, 6, 7]}
                    weekView={false}
                    resourceList={getresourceList()}
                    mainResourceName={this.state.mainResourceName}
                    calendarHeight={800}
                    startTime={10}
                    endTime={19}
                  />
                )}
              </Box>
            )}
          </Box>
        </Container>

        <Footer />
      </>
    )
  }
};


export default SingleGroup;